import { createContext, type Context } from 'react';
import type { ViewMode } from '@jira/issue__issue-preview-view-mode-storage/src/getViewModeFromLocalStorage.tsx';

export type HydratedViewMode = ViewMode | null | undefined;

// Package-internal context for the current preview-mode value. External consumers must subscribe
// through useViewMode(); this context is not part of the public API.
export const viewModeStateContext: Context<HydratedViewMode> =
	createContext<HydratedViewMode>(null);
